import React from 'react'

const UploadIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid" {...props}>
        <path d="M18 23.9H2c-1.102 0-2-.894-2-1.992V8.956c0-1.098.898-1.992 2-1.992h4c.553 0 1 .445 1 .996 0 .551-.447.946-1 .946H2v13.002h16V8.906h-4c-.553 0-1-.395-1-.946a.997.997 0 0 1 1-.996h4c1.103 0 2 .894 2 1.992v12.952a1.998 1.998 0 0 1-2 1.992zM13 4.971a.996.996 0 0 1-.707-.292L11 3.391v11.543a.997.997 0 0 1-1 .996c-.553 0-1-.445-1-.996V3.391L7.707 4.679a1 1 0 0 1-1.414 0 .992.992 0 0 1 0-1.408L9.291.283c.093-.092.204-.166.327-.217.116-.047.239-.07.362-.072.007 0 .013-.004.02-.004.007 0 .013.004.02.004.123.002.246.025.362.072.123.051.234.125.326.217l2.999 2.988a.996.996 0 1 1-.707 1.7z" fillRule="evenodd"/>
    </svg>
)



export default UploadIcon


// WEBPACK FOOTER //
// ./src/components/_common/_icons/Upload.js